import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from "@/i18n/messages";
import {Locale} from "vant";
import enUS from "vant/lib/locale/lang/en-US";
import zhCN from "vant/lib/locale/lang/zh-CN";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'ch',
  messages
});

export const i18nMixin = {
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    isCh() {
      return this.locale === 'ch';
    },
    isEn() {
      return this.locale === 'en';
    }
  },
}

/**
 * 设置Vant语言包
 * @param locale
 */
export function setVantLocale(locale) {
  if (locale === 'ch') Locale.use('zh-CN', zhCN);
  else Locale.use('en-US', enUS);
}



// WEBPACK FOOTER //
// ./src/i18n/i18n.js